import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=261a2c1f"
import script from "./StudentPage.vue?vue&type=script&lang=ts"
export * from "./StudentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports